import React from 'react';
import { useProject } from '../context/ProjectContext';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { selectedProjectID, setSelectedProjectID, projects } = useProject();
  const { userInfo } = useAuth();
  const sigurniProjekti = Array.isArray(projects) ? projects : [];

  const fullName = userInfo?.fullName || 'Korisnik';

  return (
    <header className="flex justify-between items-center px-4 md:px-8 h-16 sticky top-0 bg-white/90 backdrop-blur-md z-30 border-b border-slate-200">
      
      {/* LIJEVA STRANA: ČISTI SELEKTOR PROJEKTA */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 bg-slate-50 hover:bg-slate-100 transition-all px-3 py-1.5 rounded-xl border border-slate-200 text-xs font-bold text-slate-800 shadow-2xs">
          <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0"></span>
          
          <select
            value={selectedProjectID}
            onChange={(e) => setSelectedProjectID(e.target.value)}
            className="bg-transparent border-0 outline-none cursor-pointer text-xs font-bold text-slate-800 focus:ring-0 p-0 pr-6 m-0"
          >
            {sigurniProjekti.length === 0 ? (
              <option value="1">Brda Projekt A,B (Split)</option>
            ) : (
              sigurniProjekti.map(p => (
                <option key={p.projectID} value={String(p.projectID)}>
                  {p.projectName} {p.location ? `(${p.location})` : ''}
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {/* DESNA STRANA: ČISTI STATUS KORISNIKA */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 text-xs font-semibold text-slate-600 bg-slate-50 px-3 py-1.5 rounded-xl border border-slate-100">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
          <span className="text-slate-800 font-bold">{fullName}</span>
        </div>
      </div>

    </header>
  );
}